import { Injectable } from '@angular/core';
import { SearchFacet, SearchFilterFilter } from '@app/search/search-api.model';
import { SearchService } from '@app/search/services/search.service';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root',
})
export class AddBySearchService {
  public i18n = this.translateService.instant([
    'TargetResourcesForm_Filters_PlansAndPathways', // Plans and Pathways
    'TargetResourcesForm_Filters_Catalog', // Catalog
    'TargetResourcesForm_Filters_Resources', // Resources
  ]);
  constructor(
    private searchService: SearchService,
    private translateService: TranslateService
  ) {}

  public facetsToFilters(
    facets: SearchFacet[],
    config: any[] = []
  ): SearchFilterFilter[] {
    const filters = this.searchService.facetsToFilters(facets, config);
    // handle type filter
    const typeIndex = filters.findIndex((filter) => filter.model.id === 'Type');
    filters[typeIndex] = this.segmentFilter(filters[typeIndex]);
    // return filters
    return filters;
  }

  private segmentFilter(filter: SearchFilterFilter) {
    const segmentedSubitems = filter.subitems.map((subitem) => {
      switch (subitem.model.id) {
        // plans and directories
        case 'target':
        case 'pathway':
          return {
            ...subitem,
            group: 1,
          };
        // group people provider skill
        case 'user':
        case 'group':
        case 'provider':
        case 'tag':
          // correct title of certain types
          if (subitem.model.id === 'user') {
            subitem.title = 'People';
          }
          // return item
          return {
            ...subitem,
            group: 2,
          };
        // catalog
        default:
          return {
            ...subitem,
            group: 0,
          };
      }
    });

    return {
      ...filter,
      config: {
        ...filter.config,
        isSegmentedFilter: true,
        segments: [
          {
            title: this.i18n.TargetResourcesForm_Filters_Catalog,
            isCollapsed: false,
          },
          {
            title: this.i18n.TargetResourcesForm_Filters_PlansAndPathways,
            isCollapsed: true,
          },
          {
            title: this.i18n.TargetResourcesForm_Filters_Resources,
            isCollapsed: true,
          },
        ],
      },
      subitems: segmentedSubitems,
    };
  }
}
